<template>
  <button class="comment-fav" @click="like">
    <!-- TODO extract svg -->
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fas"
      data-icon="heart"
      class="svg-inline--fa fa-heart fa-w-16"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill="currentColor"
        d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
      ></path>
    </svg>
    <span>{{ localLikes }}</span>
  </button>
</template>

<script>
export default {
  props: {
    likes: {
      type: Number,
      required: true
    },
    isLiked: {
      type: Boolean,
      required: true
    },
    modelId: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      localLikes: this.likes,
      localIsLiked: this.isLiked
    }
  },
  methods: {
    like() {
      let url = this.type === 'thread' ? `diskuze/${this.modelId}/like` : `komentare/${this.modelId}/like`

      $(this.$el).parents('.comment-wrapper').toggleClass('liked')

      this.localLikes += this.localIsLiked ? -1 : 1
      this.localIsLiked = !this.localIsLiked

      axios.put(`/forum/${url}`)
    }
  }
}
</script>
